export default __webpack_public_path__ + "static/media/Loincloth of the Darkwretch.160508ed.jpg";